export default "__VITE_ASSET__CJ$otgGw__"